import PersistenceRegistry from '../../../react/features/base/redux/PersistenceRegistry';
import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import { SET_CONFERENCE_LANG } from './actionTypes';
/**
 * The redux subtree of this feature.
 */
const STORE_NAME = 'xbees/base/conference';
const defaultState = {
    systemLanguage: undefined
};
/**
 * Sets up the persistence of the feature {@code store}.
 */
PersistenceRegistry.register(STORE_NAME);
ReducerRegistry.register(STORE_NAME, (state = defaultState, action) => {
    switch (action.type) {
        case SET_CONFERENCE_LANG:
            return {
                ...state,
                systemLanguage: action.systemLanguage
            };
    }
    return state;
});
